export interface SideBarChild {
  name: string;
  route: string[];
}

export interface SideBarItem {
  name: string;
  route: string[];
  childrenPath: string[];
  children: SideBarChild[];
  img: string;
}

export const SIDE_BAR_DATA: SideBarItem[] = [
  {
    name: 'Familles & Articles',
    route: [],
    childrenPath: [
      'article/family',
      'article/list',
      'article/setting',
      'article/details/:id',
      'article/add',
      'article/edit/:id',
      'article/prices/:id',
      'article-pack/list',
      'article-pack/add',
      'article-pack/edit/:id',
      'ptl',
    ],
    children: [
      {name: 'Familles', route: ['article/family']},
      {name: 'Articles', route: ['article/list', 'article/details/:id']},
      {name: 'Packs', route: ['article-pack/list', 'article-pack/add', 'article-pack/edit/:id']},
      {name: 'Paramétrage', route: ['article/setting']},
      {name: 'PTL', route: ['ptl']}
    ],
    img: 'article-icon'
  },
  {
    name: 'Commandes',
    route: [],
    childrenPath: ['orders', 'order-details/:id'],
    children: [
      {name: 'Liste', route: ['orders']},
      {name: 'Réexpedition', route: ['ordershipreturn/list']}
    ],
    img: 'orders-icon'
  },
  {
    name: 'Users',
    route: [],
    childrenPath: [
      'user/list',
      'user-profile/:id',
      'discount-code/list',
      'discount-code/add',
      'user/new'
    ],
    children: [
      {name: 'Liste des users', route: ['user/list']},
      {name: 'Codes promo', route: ['discount-code/list']}
    ],
    img: 'users-icon'
  },
  {
    name: 'Lavandiers',
    route: [],
    childrenPath: [
      'lavandier/list',
      'lavandier/details/:id',
      'lavandier/add',
      'role/list',
      'role/details/:id',
      'role/add'
    ],
    children: [
      {name: 'Liste des lavandiers', route: ['lavandier/list']},
      {name: 'Liste des rôles', route: ['role/list']}
    ],
    img: 'lavandier-icon'
  },
  {
    name: 'Impekkable',
    route: [],
    childrenPath: [
      'calendar',
      'user-type-setting',
      'user-type-setting/edit/:userTypeId',
      'account/new/:userTypeId',
      'account/edit/:id'
    ],
    children: [
      {name: 'Calendrier', route: ['calendar']},
      {name: 'Paramétrage Type utilisateur', route: ['user-type-setting']}
    ],
    img: 'logo'
  }
];
